export default "__VITE_ASSET__DgnfwJol__"